import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { BeforeAfter } from './components/BeforeAfter';
import { PainPoints } from './components/PainPoints';
import { WhatsInside } from './components/WhatsInside';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { About } from './components/About';
import { FAQ } from './components/FAQ';
import { FinalCTA, Footer } from './components/FinalCTA';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="w-full bg-white" data-id="element-0" data-mp="28u5zysgmvffh">
      <MetaPixel data-id="element-1" data-mp="28t4l0cwhy8sh" />
      <main className="w-full" data-id="element-2" data-mp="28sl511qepuh3">
        <Hero data-id="element-3" data-mp="23vcmh01cjofb" />
        <Stats data-id="element-4" data-mp="23vuoyeelqyvo" />
        <BeforeAfter data-id="element-5" data-mp="23u9uspw79hyc" />
        <PainPoints data-id="element-6" data-mp="23ut97wmn5o7m" />
        <WhatsInside data-id="element-7" data-mp="23ti8k5ohswkq" />
        <Bonuses data-id="element-8" data-mp="3ik7eyd5x05p2" />
        <Offer data-id="element-9" data-mp="3ikqy1x7ax04o" />
        <Guarantee data-id="element-10" data-mp="3ij63w8owfj7c" />
        <Testimonials data-id="element-11" data-mp="3ijpcuzwkmx98" />
        <About data-id="element-12" data-mp="3mlja0y7k5j4n" />
        <FAQ data-id="element-13" data-mp="3mlat8v8bdto6" />
        <FinalCTA data-id="element-14" data-mp="3mkrbpfmkt7ao" />
      </main>
      <Footer data-id="element-15" data-mp="3mjztd6hzp62c" />
      <FloatingCTA data-id="element-16" data-mp="3mjg8bgx1m1k3" />
      <PurchasePopup data-id="element-17" data-mp="3rc9ca2kot5v4" />
    </div>;
}